import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
// Ensure we don't end up with //api if BACKEND_URL is "/"
export const API = (BACKEND_URL === "/" ? "" : BACKEND_URL) + "/api";


export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ditnarkoba_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const KABUPATEN_JATENG = [
  "Kota Semarang", "Kab. Semarang", "Kota Surakarta", "Kota Salatiga", "Kota Pekalongan", "Kota Tegal", "Kota Magelang",
  "Kab. Banjarnegara", "Kab. Banyumas", "Kab. Batang", "Kab. Blora", "Kab. Boyolali", "Kab. Brebes", "Kab. Cilacap",
  "Kab. Demak", "Kab. Grobogan", "Kab. Jepara", "Kab. Karanganyar", "Kab. Kebumen", "Kab. Kendal", "Kab. Klaten",
  "Kab. Kudus", "Kab. Magelang", "Kab. Pati", "Kab. Pekalongan", "Kab. Pemalang", "Kab. Purbalingga", "Kab. Purworejo",
  "Kab. Rembang", "Kab. Sragen", "Kab. Sukoharjo", "Kab. Tegal", "Kab. Temanggung", "Kab. Wonogiri", "Kab. Wonosobo",
];

export const JENIS_NARKOBA = [
  "Sabu-sabu (Metamfetamina)",
  "Ganja",
  "Ekstasi",
  "Heroin",
  "Kokain",
  "Obat-obatan Terlarang",
  "Tembakau Sintetis",
  "Lainnya",
];

export const STATUS_LABEL = {
  baru: "Baru Masuk",
  diverifikasi: "Diverifikasi",
  dalam_penyelidikan: "Dalam Penyelidikan",
  selesai: "Selesai",
  ditolak: "Ditolak",
};
